﻿(function (angular, ToyotaForms) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyValidPhone', ['$filter', 'API', '$q', function Map($filter, API, $q) {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    var phoneNumber;

                    ctrl.$asyncValidators.phone = function (modelValue, viewValue) {

                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return $q.when();
                        }

                        var def = $q.defer();

                        phoneNumber = $filter('formatArgs')(ToyotaForms.API.Validation.Phone, [modelValue]);

                        if (/^0[2-57-8]\d{8}$/.test(viewValue)) {
                            ctrl.$setTouched();

                            API.get(phoneNumber, null, true)
                                .then(function (req) {
                                    if (req.data.isValid) {
                                        def.resolve();
                                    }
                                    else {
                                        def.reject();
                                    }
                                }, function () {
                                    def.reject();
                                });
                        } else {
                            // Reject it because it doesn't even match the number-vetting regex.
                            def.reject();
                        }

                        return def.promise;
                    };
                }
            };
        }]);
})(window.angular, window.ToyotaForms);
